export const STEPS_DATA = [
  {
    image:
      'https://crehana-vercel-images-prd.imgix.net/public/bc2155a3-809d-48b3-86a0-d4134f11f5ee-step_1.png?auto=format&fit=clip',
    text: 'Ingresa a Yape en tu celular',
    textWidth: 'w-144',
  },
  {
    image:
      'https://crehana-vercel-images-prd.imgix.net/public/6c5903bc-8d24-4bd5-8f57-f21d0d9a07d1-step_2.png?auto=format&fit=clip',
    text: 'Selecciona el botón para escanear el QR',
    textWidth: 'w-160',
  },
  {
    image:
      'https://crehana-vercel-images-prd.imgix.net/public/136af09e-1dcc-4076-aa58-69a40d48c1ec-step_3.png?auto=format&fit=clip',
    text: '¡Escanea el QR y listo!',
    textWidth: 'w-96',
  },
];
